import Drawer from "../../../../drawer/Drawer";
import ManageEvent from "../ManageEvent";

const ManageEventDrawer = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl"}
      size={"xl2"}
      title={
        data?._id ? (
          <span className="tracking-tighter uppercase font-bold">
            Update Event
          </span>
        ) : (
          <span className="tracking-tighter uppercase font-bold">
            Add Event
          </span>
        )
      }
      subtitle="View, update and modify event details and information bellow"
      drawerBodyClass="p-0 max-h-[calc(100%-90px)]"
    >
      <div className="h-full overflow-y-auto">
        <ManageEvent getResponse={getResponse} close={close} data={data} />
      </div>
    </Drawer>
  );
};

export default ManageEventDrawer;
